export default __webpack_public_path__ + "assets/images/3c1741dc286f0e876782f59cbe4725cd.jpeg";